import { useLocalHooks } from './use-local-hooks';
import { VipOnlyModal, type ModalProps } from './vip-only-modal';

export type VipOnlyModalContainerProps = {
  storyId: string;
  isOpen: boolean;
  onClose: () => void;
} & Omit<ModalProps, 'isOpen' | 'onClickRegister' | 'onClose'>;

export const VipOnlyModalContainer = ({
  isOpen,
  onClose,
  storyId,
}: VipOnlyModalContainerProps) => {
  const { onClickRegister } = useLocalHooks(storyId);
  return (
    <VipOnlyModal
      isOpen={isOpen}
      onClose={onClose}
      onClickRegister={onClickRegister}
    />
  );
};
